import { Button, SxProps, Theme } from '@mui/material';
import { ButtonHTMLAttributes, MouseEventHandler, ReactNode } from 'react';
const portalButtonVariants = {
  primary: {
    color: 'white',
    textTransform: 'none',
    backgroundColor: '#282828',
    '&:hover': {
      backgroundColor: '#000000CC'
    }
  },
  secondary: {
    color: '#282828',
    textTransform: 'none',
    border: '1px solid #AFAFAF',
    borderColor: '#AFAFAF',
    backgroundColor: 'backgrounds.white',
    '& .MuiTypography-root': {
      color: '#282828'
    },
    '&:hover': {
      backgroundColor: '#AFAFAF'
    }
  },
  tertiary: {
    color: '#282828',
    textTransform: 'none',
    borderColor: '#AFAFAF',
    backgroundColor: 'backgrounds.white',
    '&:hover': {
      backgroundColor: '#AFAFAF'
    }
  }
} as const;
type PortalButtonVariant = keyof typeof portalButtonVariants;
interface PortalButtonProps {
  href?: string;
  disabled?: boolean;
  children: ReactNode;
  size?: 'S' | 'M' | 'L';
  sx?: Record<string, unknown>;
  variant?: PortalButtonVariant;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
}
export default function PortalButton({
  sx,
  href,
  onClick,
  children,
  size = 'M',
  type = 'button',
  variant = 'primary',
  disabled = false
}: PortalButtonProps) {
  const buttonSx: SxProps<Theme> = {
    ...portalButtonVariants[variant],
    ...sx
  };
  return <Button href={href} sx={buttonSx} disableElevation onClick={onClick} variant="contained" size={size} disabled={disabled} type={type} data-sentry-element="Button" data-sentry-component="PortalButton" data-sentry-source-file="PortalButton.tsx">
			{children}
		</Button>;
}